/**
 * @description Directory for ID Attributes on SabreTermsAndConditionsModal.
 * Naming Convention: "[VIEW/COMPONENT]-[ELEMENT]-[NAME]".
 * Example: id = "mainlayout-btn-cancel".
 */
const idDirectory = {
	divRoot: `termsAndConditionsModal-div-root`,
	divTitle: `termsAndConditionsModal-div-title`,
	divContent: `termsAndConditionsModal-div-content`,
	divActions: `termsAndConditionsModal-div-actions`,
	btnPrimary: `termsAndConditionsModal-btn-primary`,
	btnSecondary: `termsAndConditionsModal-btn-secondary`,
}

export default idDirectory 